import React, { useState } from 'react';
import { Search, ArrowLeft, Store as StoreIcon, MapPin, Mail, Phone, UserCircle, Package, AlertTriangle, TrendingUp, TrendingDown, Clock, CheckCircle2, Sliders, Plus, ChevronRight, ToggleLeft, ToggleRight, Pencil, Sparkles, X, Globe, LifeBuoy, PackageX } from 'lucide-react';
export type StoreData = {
  id: string;
  name: string;
  city: string;
  address: string;
  manager: {
    name: string;
    email: string;
    phone: string;
  };
  shipmentsMonth: number;
  shipmentsTrend: number;
  deliveryRate: number;
  openTickets: number;
  pendingIssues: number;
  avgDeliveryDays: number;
  openingHours: string;
  rules: number;
  status: 'active' | 'paused';
};
export const STORES: StoreData[] = [{
  id: 'STR-001',
  name: 'Store Milano Duomo',
  city: 'Milano',
  address: 'Galleria Vittorio Emanuele II, 12',
  manager: {
    name: 'Sara Bianchi',
    email: 'milano.duomo@network.store',
    phone: '+39 02 8765 4321'
  },
  shipmentsMonth: 248,
  shipmentsTrend: 6.2,
  deliveryRate: 98.4,
  openTickets: 2,
  pendingIssues: 1,
  avgDeliveryDays: 1.2,
  openingHours: '09:30–13:00 / 15:30–19:30',
  rules: 4,
  status: 'active'
}, {
  id: 'STR-002',
  name: 'Store Roma Termini',
  city: 'Roma',
  address: 'Via Marsala 25',
  manager: {
    name: 'Luca Conti',
    email: 'roma.termini@network.store',
    phone: '+39 06 4441 2200'
  },
  shipmentsMonth: 312,
  shipmentsTrend: 8.4,
  deliveryRate: 99.1,
  openTickets: 0,
  pendingIssues: 0,
  avgDeliveryDays: 0.9,
  openingHours: '08:00–22:00',
  rules: 3,
  status: 'active'
}, {
  id: 'STR-003',
  name: 'Store Firenze Centro',
  city: 'Firenze',
  address: 'Via Roma 24',
  manager: {
    name: 'Chiara Greco',
    email: 'firenze.centro@network.store',
    phone: '+39 055 2398 411'
  },
  shipmentsMonth: 186,
  shipmentsTrend: 2.1,
  deliveryRate: 98.4,
  openTickets: 1,
  pendingIssues: 2,
  avgDeliveryDays: 1.3,
  openingHours: '10:00–13:30 / 15:00–19:30',
  rules: 5,
  status: 'active'
}, {
  id: 'STR-004',
  name: 'Store Bari Mungivacca',
  city: 'Bari',
  address: 'Strada Provinciale 60, km 4',
  manager: {
    name: 'Marco De Rosa',
    email: 'bari.mungivacca@network.store',
    phone: '+39 080 5520 130'
  },
  shipmentsMonth: 142,
  shipmentsTrend: -1.4,
  deliveryRate: 96.2,
  openTickets: 3,
  pendingIssues: 4,
  avgDeliveryDays: 1.7,
  openingHours: '09:00–13:00 / 16:00–20:00',
  rules: 2,
  status: 'active'
}, {
  id: 'STR-005',
  name: 'Store Palermo La Torre',
  city: 'Palermo',
  address: 'Via Vincenzo La Torre 7',
  manager: {
    name: 'Giulia Romano',
    email: 'palermo.latorre@network.store',
    phone: '+39 091 6118 200'
  },
  shipmentsMonth: 124,
  shipmentsTrend: 3.7,
  deliveryRate: 94.8,
  openTickets: 1,
  pendingIssues: 3,
  avgDeliveryDays: 2.4,
  openingHours: '09:30–13:30 / 16:30–20:00',
  rules: 3,
  status: 'active'
}, {
  id: 'STR-006',
  name: 'Store Catania Etnapolis',
  city: 'Catania',
  address: 'Strada 5° Etnapolis',
  manager: {
    name: 'Alessandro Marino',
    email: 'catania.etnapolis@network.store',
    phone: '+39 095 7142 800'
  },
  shipmentsMonth: 98,
  shipmentsTrend: -3.2,
  deliveryRate: 92.1,
  openTickets: 2,
  pendingIssues: 5,
  avgDeliveryDays: 2.6,
  openingHours: '09:00–21:00',
  rules: 1,
  status: 'paused'
}, {
  id: 'STR-007',
  name: 'Store Torino Lingotto',
  city: 'Torino',
  address: 'Via Nizza 230',
  manager: {
    name: 'Elena Ferrari',
    email: 'torino.lingotto@network.store',
    phone: '+39 011 6677 901'
  },
  shipmentsMonth: 174,
  shipmentsTrend: 4.8,
  deliveryRate: 98.0,
  openTickets: 0,
  pendingIssues: 1,
  avgDeliveryDays: 1.4,
  openingHours: '09:30–21:30',
  rules: 4,
  status: 'active'
}, {
  id: 'STR-008',
  name: 'Store Bologna Centro',
  city: 'Bologna',
  address: "Via dell'Indipendenza 47",
  manager: {
    name: 'Davide Russo',
    email: 'bologna.centro@network.store',
    phone: '+39 051 2388 411'
  },
  shipmentsMonth: 156,
  shipmentsTrend: 5.1,
  deliveryRate: 98.9,
  openTickets: 0,
  pendingIssues: 0,
  avgDeliveryDays: 1.2,
  openingHours: '09:30–19:30',
  rules: 3,
  status: 'active'
}];
type RuleCategory = 'Tempistiche' | 'Sicurezza' | 'Notifiche' | 'Vettori' | 'Documenti';
type Rule = {
  id: string;
  title: string;
  description: string;
  category: RuleCategory;
};
const RULES_CATALOG: Rule[] = [{
  id: 'RUL-001',
  title: 'Evita pausa pranzo',
  description: 'Non programmare consegne nella fascia 13:00–15:30.',
  category: 'Tempistiche'
}, {
  id: 'RUL-002',
  title: 'Doppia firma per consegne sopra €1.000',
  description: 'Richiede due firme per spedizioni di valore elevato.',
  category: 'Sicurezza'
}, {
  id: 'RUL-003',
  title: 'Notifica SMS al referente',
  description: 'Invia SMS al manager 30 min prima della consegna.',
  category: 'Notifiche'
}, {
  id: 'RUL-004',
  title: 'Consegne preferibilmente al mattino',
  description: 'Predilige slot 08:00–12:00 quando possibile.',
  category: 'Tempistiche'
}, {
  id: 'RUL-005',
  title: 'Vettore preferito: FedEx',
  description: 'Assegna FedEx come vettore primario per ritiri da magazzino.',
  category: 'Vettori'
}, {
  id: 'RUL-006',
  title: 'Foto consegna obbligatoria',
  description: "Richiede foto del pacco all'arrivo per ogni consegna.",
  category: 'Documenti'
}, {
  id: 'RUL-007',
  title: 'Auto-riprogrammazione domenica',
  description: 'Posticipa automaticamente consegne in arrivo di domenica.',
  category: 'Tempistiche'
}, {
  id: 'RUL-008',
  title: 'Conferma indirizzo prima della spedizione',
  description: 'Verifica automatica del CAP per le tratte del sud.',
  category: 'Sicurezza'
}];
// Default rule → stores assignment. Determines which rules are applied to each store.
const INITIAL_ASSIGNMENTS: Record<string, string[]> = {
  'RUL-001': ['STR-001'],
  'RUL-002': ['STR-001', 'STR-007'],
  'RUL-003': ['STR-001', 'STR-002', 'STR-008'],
  'RUL-004': ['STR-002'],
  'RUL-005': ['STR-002', 'STR-007'],
  'RUL-006': ['STR-003', 'STR-005'],
  'RUL-007': [],
  'RUL-008': ['STR-004', 'STR-005']
};
type StoreProps = {
  section: 'list' | 'referenti' | 'statistiche';
  onOpenTickets?: () => void;
  onOpenGiacenze?: () => void;
  onOpenRitardi?: () => void;
};
export function Store({
  section,
  onOpenTickets,
  onOpenGiacenze,
  onOpenRitardi
}: StoreProps) {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const selected = STORES.find(s => s.id === selectedId) || null;
  if (selected) {
    return <StoreDetail store={selected} onBack={() => setSelectedId(null)} onOpenTickets={onOpenTickets} onOpenGiacenze={onOpenGiacenze} onOpenRitardi={onOpenRitardi} data-id="element-2947" />;
  }
  if (section === 'referenti') return <ReferentiView data-id="element-2948" />;
  if (section === 'statistiche') return <StatisticheView data-id="element-2949" />;
  return <StoreList onSelect={setSelectedId} data-id="element-2950" />;
}
function StoreList({
  onSelect
}: {
  onSelect: (id: string) => void;
}) {
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState<'Tutti' | 'Attivi' | 'In pausa'>('Tutti');
  const filtered = STORES.filter(s => {
    if (filter === 'Attivi' && s.status !== 'active') return false;
    if (filter === 'In pausa' && s.status !== 'paused') return false;
    const q = query.trim().toLowerCase();
    if (q && !`${s.name} ${s.city}`.toLowerCase().includes(q)) return false;
    return true;
  });
  const totalShipments = STORES.reduce((a, s) => a + s.shipmentsMonth, 0);
  const totalOpenTickets = STORES.reduce((a, s) => a + s.openTickets, 0);
  const totalPendingIssues = STORES.reduce((a, s) => a + s.pendingIssues, 0);
  const avgDeliveryRate = STORES.reduce((a, s) => a + s.deliveryRate, 0) / STORES.length;
  return <div className="space-y-6" data-id="element-2951">
      <div className="flex items-end justify-between flex-wrap gap-3" data-id="element-2952">
        <div data-id="element-2953">
          <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-2954">
            Store
          </h1>
        </div>
        <button className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-2955">
          <Plus className="h-4 w-4" data-id="element-2956" />
          Aggiungi store
        </button>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-2957">
        <KpiTile label="Store attivi" value={String(STORES.filter(s => s.status === 'active').length)} icon={<StoreIcon className="h-4 w-4 text-[#D4FF3A]" data-id="element-2959" />} data-id="element-2958" />
        <KpiTile label="Spedizioni mese" value={totalShipments.toLocaleString('it-IT')} icon={<Package className="h-4 w-4 text-[#9A9A9A]" data-id="element-2961" />} data-id="element-2960" />
        <KpiTile label="Tasso consegna medio" value={`${avgDeliveryRate.toFixed(1)}%`} icon={<CheckCircle2 className="h-4 w-4 text-[#D4FF3A]" data-id="element-2963" />} data-id="element-2962" />
        <KpiTile label="Ticket aperti" value={String(totalOpenTickets)} icon={<AlertTriangle className="h-4 w-4 text-[#F5A524]" data-id="element-2965" />} data-id="element-2964" />
      </div>

      {/* Filters + search */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-2" data-id="element-2966">
        <div className="-mx-4 sm:mx-0 px-4 sm:px-0 overflow-x-auto" data-id="element-2967">
          <div className="flex items-center gap-1 p-1 rounded-lg bg-[#181818] border border-[#262626] w-max" data-id="element-2968">
            {(['Tutti', 'Attivi', 'In pausa'] as const).map(f => <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${filter === f ? 'bg-[#0A0A0A] text-[#FAFAFA] border border-[#262626]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-2969">
                {f}
              </button>)}
          </div>
        </div>
        <div className="relative w-full sm:w-64 sm:ml-auto" data-id="element-2970">
          <Search className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-2971" />
          <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Cerca store o città..." className="w-full pl-9 pr-3 py-2 rounded-lg bg-[#181818] border border-[#262626] text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30" data-id="element-2972" />
        </div>
      </div>

      {/* Grid */}
      {filtered.length === 0 ? <div className="bg-[#181818] border border-[#262626] rounded-xl p-12 text-center text-sm text-[#9A9A9A]" data-id="element-2973">
          Nessuno store trovato.
        </div> : <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-2974">
          {/* Desktop table */}
          <div className="hidden md:block overflow-x-auto" data-id="element-2975">
            <table className="w-full text-sm [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap" data-id="element-2976">
              <thead data-id="element-2977">
                <tr className="text-left text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#1F1F1F]" data-id="element-2978">
                  <th className="px-5 py-3 font-medium" data-id="element-2979">Store</th>
                  <th className="px-5 py-3 font-medium" data-id="element-2980">Città</th>
                  <th className="px-5 py-3 font-medium" data-id="element-2981">Referente</th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-2982">
                    Spedizioni mese
                  </th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-2983">Consegna</th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-2984">ETA</th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-2985">Ticket</th>
                  <th className="px-5 py-3 font-medium text-right" data-id="element-2986">
                    Giacenze/Ritardi
                  </th>
                  <th className="px-5 py-3 font-medium" data-id="element-2987">Stato</th>
                  <th className="px-5 py-3" data-id="element-2988" />
                </tr>
              </thead>
              <tbody data-id="element-2989">
                {filtered.map(s => <tr key={s.id} onClick={() => onSelect(s.id)} className="border-b border-[#1F1F1F] last:border-0 hover:bg-[#0A0A0A] transition-colors cursor-pointer" data-id="element-2990">
                    <td className="px-5 py-3.5" data-id="element-2991">
                      <div className="flex items-center gap-2.5" data-id="element-2992">
                        <div className="h-8 w-8 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-2993">
                          <StoreIcon className="h-4 w-4 text-[#D4FF3A]" data-id="element-2994" />
                        </div>
                        <div className="min-w-0" data-id="element-2995">
                          <div className="text-sm text-[#FAFAFA] truncate" data-id="element-2996">
                            {s.name}
                          </div>
                          <div className="text-[10px] text-[#6B6B6B] font-mono" data-id="element-2997">
                            {s.id}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-[#9A9A9A]" data-id="element-2998">
                      <span className="inline-flex items-center gap-1.5" data-id="element-2999">
                        <MapPin className="h-3 w-3 text-[#6B6B6B]" data-id="element-3000" />
                        {s.city}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-[#9A9A9A]" data-id="element-3001">
                      <div className="truncate max-w-[180px]" data-id="element-3002">
                        {s.manager.name}
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-right" data-id="element-3003">
                      <div className="inline-flex items-center justify-end gap-2" data-id="element-3004">
                        <span className="font-mono text-[#FAFAFA]" data-id="element-3005">
                          {s.shipmentsMonth.toLocaleString('it-IT')}
                        </span>
                        <TrendPill value={s.shipmentsTrend} small data-id="element-3006" />
                      </div>
                    </td>
                    <td className={`px-5 py-3.5 text-right font-mono ${s.deliveryRate >= 98 ? 'text-[#D4FF3A]' : 'text-[#FAFAFA]'}`} data-id="element-3007">
                      {s.deliveryRate}%
                    </td>
                    <td className="px-5 py-3.5 text-right font-mono text-[#9A9A9A]" data-id="element-3008">
                      {s.avgDeliveryDays}g
                    </td>
                    <td className={`px-5 py-3.5 text-right font-mono ${s.openTickets > 0 ? 'text-[#F5A524]' : 'text-[#9A9A9A]'}`} data-id="element-3009">
                      {s.openTickets}
                    </td>
                    <td className={`px-5 py-3.5 text-right font-mono ${s.pendingIssues > 0 ? 'text-[#EF4444]' : 'text-[#9A9A9A]'}`} data-id="element-3010">
                      {s.pendingIssues}
                    </td>
                    <td className="px-5 py-3.5" data-id="element-3011">
                      <StoreStatusBadge status={s.status} data-id="element-3012" />
                    </td>
                    <td className="px-5 py-3.5 text-right" data-id="element-3013">
                      <ChevronRight className="h-4 w-4 text-[#6B6B6B] inline" data-id="element-3014" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile cards */}
          <div className="md:hidden divide-y divide-[#1F1F1F]" data-id="element-3015">
            {filtered.map(s => <button key={s.id} onClick={() => onSelect(s.id)} className="w-full text-left p-4 active:bg-[#0A0A0A] transition-colors" data-id="element-3016">
                <div className="flex items-start justify-between gap-3 mb-2" data-id="element-3017">
                  <div className="flex items-start gap-2.5 min-w-0" data-id="element-3018">
                    <div className="h-8 w-8 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3019">
                      <StoreIcon className="h-4 w-4 text-[#D4FF3A]" data-id="element-3020" />
                    </div>
                    <div className="min-w-0" data-id="element-3021">
                      <div className="text-sm font-semibold text-[#FAFAFA] truncate" data-id="element-3022">
                        {s.name}
                      </div>
                      <div className="text-xs text-[#9A9A9A] flex items-center gap-1 mt-0.5" data-id="element-3023">
                        <MapPin className="h-3 w-3 text-[#6B6B6B]" data-id="element-3024" />
                        {s.city}
                      </div>
                    </div>
                  </div>
                  <StoreStatusBadge status={s.status} data-id="element-3025" />
                </div>
                <div className="grid grid-cols-4 gap-3 pt-2 text-xs" data-id="element-3026">
                  <div data-id="element-3027">
                    <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3028">
                      Volume
                    </div>
                    <div className="font-mono text-[#FAFAFA] mt-0.5" data-id="element-3029">
                      {s.shipmentsMonth}
                    </div>
                  </div>
                  <div data-id="element-3030">
                    <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3031">
                      Cons.
                    </div>
                    <div className={`font-mono mt-0.5 ${s.deliveryRate >= 98 ? 'text-[#D4FF3A]' : 'text-[#FAFAFA]'}`} data-id="element-3032">
                      {s.deliveryRate}%
                    </div>
                  </div>
                  <div data-id="element-3033">
                    <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3034">
                      ETA
                    </div>
                    <div className="font-mono text-[#9A9A9A] mt-0.5" data-id="element-3035">
                      {s.avgDeliveryDays}g
                    </div>
                  </div>
                  <div data-id="element-3036">
                    <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3037">
                      Ticket
                    </div>
                    <div className={`font-mono mt-0.5 ${s.openTickets > 0 ? 'text-[#F5A524]' : 'text-[#9A9A9A]'}`} data-id="element-3038">
                      {s.openTickets}
                    </div>
                  </div>
                </div>
              </button>)}
          </div>
        </div>}
    </div>;
}
function StoreDetail({
  store,
  onBack,
  onOpenTickets,
  onOpenGiacenze,
  onOpenRitardi
}: {
  store: StoreData;
  onBack: () => void;
  onOpenTickets?: () => void;
  onOpenGiacenze?: () => void;
  onOpenRitardi?: () => void;
}) {
  return <div className="space-y-6" data-id="element-3039">
      <button onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-[#9A9A9A] hover:text-[#FAFAFA] transition-colors" data-id="element-3040">
        <ArrowLeft className="h-4 w-4" data-id="element-3041" />
        <span data-id="element-3042">Torna agli store</span>
      </button>

      {/* Header */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl p-4 sm:p-5" data-id="element-3043">
        <div className="flex items-start justify-between gap-4 flex-wrap" data-id="element-3044">
          <div className="flex items-start gap-4" data-id="element-3045">
            <div className="h-12 w-12 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3046">
              <StoreIcon className="h-6 w-6 text-[#D4FF3A]" data-id="element-3047" />
            </div>
            <div data-id="element-3048">
              <div className="flex items-center gap-2 mb-1" data-id="element-3049">
                <span className="text-xs font-mono text-[#9A9A9A]" data-id="element-3050">
                  {store.id}
                </span>
                <StoreStatusBadge status={store.status} data-id="element-3051" />
              </div>
              <h1 className="text-xl font-semibold text-[#FAFAFA] font-heading" data-id="element-3052">
                {store.name}
              </h1>
              <div className="text-sm text-[#9A9A9A] mt-0.5 flex items-center gap-1.5" data-id="element-3053">
                <MapPin className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-3054" />
                {store.address}, {store.city}
              </div>
              <div className="text-xs text-[#6B6B6B] mt-1 flex items-center gap-1.5" data-id="element-3055">
                <Clock className="h-3 w-3" data-id="element-3056" />
                {store.openingHours}
              </div>
            </div>
          </div>
          <button className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-[#181818] border border-[#262626] text-[#9A9A9A] hover:text-[#FAFAFA] hover:border-[#333] text-xs font-medium transition" data-id="element-3057">
            <Pencil className="h-3.5 w-3.5" data-id="element-3058" />
            Modifica
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-3059">
        <KpiTile label="Spedizioni mese" value={store.shipmentsMonth.toLocaleString('it-IT')} icon={<Package className="h-4 w-4 text-[#9A9A9A]" data-id="element-3061" />} trend={store.shipmentsTrend} data-id="element-3060" />
        <KpiTile label="Tasso consegna" value={`${store.deliveryRate}%`} icon={<CheckCircle2 className="h-4 w-4 text-[#D4FF3A]" data-id="element-3063" />} data-id="element-3062" />
        <KpiTile label="ETA media" value={`${store.avgDeliveryDays}g`} icon={<Clock className="h-4 w-4 text-[#9A9A9A]" data-id="element-3065" />} data-id="element-3064" />
        <KpiTile label="Ticket aperti" value={String(store.openTickets)} icon={<AlertTriangle className="h-4 w-4 text-[#F5A524]" data-id="element-3067" />} data-id="element-3066" />
      </div>

      {/* Referente */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl p-5" data-id="element-3068">
        <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading mb-4" data-id="element-3069">
          Referente principale
        </h3>
        <div className="flex items-center gap-3 mb-4" data-id="element-3070">
          <div className="h-10 w-10 rounded-full bg-[#0A0A0A] border border-[#262626] flex items-center justify-center" data-id="element-3071">
            <UserCircle className="h-6 w-6 text-[#9A9A9A]" data-id="element-3072" />
          </div>
          <div className="min-w-0" data-id="element-3073">
            <div className="text-sm font-semibold text-[#FAFAFA] truncate" data-id="element-3074">
              {store.manager.name}
            </div>
            <div className="text-xs text-[#6B6B6B] mt-0.5" data-id="element-3075">Store Manager</div>
          </div>
        </div>
        <div className="space-y-2 text-xs" data-id="element-3076">
          <div className="flex items-center gap-2 text-[#9A9A9A]" data-id="element-3077">
            <Mail className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-3078" />
            <span className="font-mono truncate" data-id="element-3079">{store.manager.email}</span>
          </div>
          <div className="flex items-center gap-2 text-[#9A9A9A]" data-id="element-3080">
            <Phone className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-3081" />
            <span className="font-mono" data-id="element-3082">{store.manager.phone}</span>
          </div>
        </div>
      </div>

      {/* Operatività: Ticket + Giacenze/Ritardi */}
      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3083">
        <div className="px-5 py-4 border-b border-[#262626] flex items-center justify-between flex-wrap gap-2" data-id="element-3084">
          <h3 className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-3085">
            Operatività
          </h3>
          <span className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3086">
            Stato corrente
          </span>
        </div>
        <div className="divide-y divide-[#1F1F1F]" data-id="element-3087">
          <OperationRow icon={<LifeBuoy className="h-4 w-4 text-[#F5A524]" data-id="element-3089" />} label="Ticket aperti" description="Richieste di supporto in corso dai clienti." count={store.openTickets} countColor={store.openTickets > 0 ? 'text-[#F5A524]' : 'text-[#9A9A9A]'} actionLabel="Apri Ticket" onAction={onOpenTickets} emptyMessage="Nessun ticket attivo." data-id="element-3088" />
          <OperationRow icon={<PackageX className="h-4 w-4 text-[#EF4444]" data-id="element-3091" />} label="Giacenze in corso" description="Pacchi non consegnati e da recuperare." count={Math.ceil(store.pendingIssues / 2)} countColor={store.pendingIssues > 0 ? 'text-[#EF4444]' : 'text-[#9A9A9A]'} actionLabel="Apri Giacenze" onAction={onOpenGiacenze} emptyMessage="Nessuna giacenza attiva." data-id="element-3090" />
          <OperationRow icon={<Clock className="h-4 w-4 text-[#F5A524]" data-id="element-3093" />} label="Ritardi attivi" description="Spedizioni in ritardo rispetto all'ETA." count={Math.floor(store.pendingIssues / 2)} countColor={store.pendingIssues > 0 ? 'text-[#F5A524]' : 'text-[#9A9A9A]'} actionLabel="Apri Ritardi" onAction={onOpenRitardi} emptyMessage="Nessun ritardo attivo." data-id="element-3092" />
        </div>
      </div>

      {/* AI insight */}
      <div className="bg-gradient-to-br from-[#181818] to-[#1a1d10] border border-[#D4FF3A]/20 rounded-xl p-5" data-id="element-3094">
        <div className="flex items-start gap-3" data-id="element-3095">
          <div className="h-8 w-8 rounded-lg bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 flex items-center justify-center shrink-0" data-id="element-3096">
            <Sparkles className="h-4 w-4 text-[#D4FF3A]" data-id="element-3097" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-3098">
            <div className="text-xs font-semibold text-[#D4FF3A] uppercase tracking-wider mb-1" data-id="element-3099">
              Insight Aisac
            </div>
            <p className="text-sm text-[#FAFAFA] leading-relaxed" data-id="element-3100">
              {store.deliveryRate >= 98 ? `${store.name} performa sopra la media del network (+${(store.deliveryRate - 96.5).toFixed(1)}%). Continua a monitorare per mantenere il livello di servizio.` : `${store.name} ha un tasso di consegna sotto il target. Verifica ticket, giacenze e ritardi per individuare le cause dei mancati recapiti.`}
            </p>
          </div>
        </div>
      </div>
    </div>;
}
function StoreRulesPickerModal({
  store,
  assignments,
  onToggle,
  onClose
}: {
  store: StoreData;
  assignments: Record<string, string[]>;
  onToggle: (ruleId: string) => void;
  onClose: () => void;
}) {
  return <div role="dialog" aria-modal="true" onClick={onClose} className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" data-id="element-3101">
      <div onClick={e => e.stopPropagation()} className="w-full sm:max-w-lg bg-[#181818] border border-[#262626] rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden" data-id="element-3102">
        <div className="p-5 border-b border-[#262626] flex items-start gap-3" data-id="element-3103">
          <div className="h-9 w-9 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3104">
            <StoreIcon className="h-4 w-4 text-[#D4FF3A]" data-id="element-3105" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-3106">
            <h2 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-3107">
              Applica regole a {store.name}
            </h2>
            <p className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3108">
              Spunta le regole del catalogo da applicare a questo store.
            </p>
          </div>
          <button type="button" onClick={onClose} aria-label="Chiudi" className="h-7 w-7 rounded flex items-center justify-center text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#222] transition" data-id="element-3109">
            <X className="h-4 w-4" data-id="element-3110" />
          </button>
        </div>
        <div className="p-5" data-id="element-3111">
          <div className="space-y-1 max-h-[60vh] overflow-y-auto" data-id="element-3112">
            {RULES_CATALOG.map(r => {
            const checked = (assignments[r.id] ?? []).includes(store.id);
            return <label key={r.id} className={`flex items-start gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition ${checked ? 'bg-[#0A0A0A] border-[#D4FF3A]/40' : 'bg-[#0A0A0A] border-[#262626] hover:border-[#333]'}`} data-id="element-3113">
                  <input type="checkbox" checked={checked} onChange={() => onToggle(r.id)} className="sr-only" data-id="element-3114" />
                  <span className={`mt-0.5 h-4 w-4 rounded border-2 shrink-0 flex items-center justify-center ${checked ? 'bg-[#D4FF3A] border-[#D4FF3A]' : 'border-[#262626]'}`} data-id="element-3115">
                    {checked && <svg className="h-3 w-3 text-[#0A0A0A]" viewBox="0 0 12 12" fill="none" data-id="element-3116">
                        <path d="M2 6l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3117" />
                      </svg>}
                  </span>
                  <div className="flex-1 min-w-0" data-id="element-3118">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-3119">
                      <span className="text-sm text-[#FAFAFA] font-medium" data-id="element-3120">
                        {r.title}
                      </span>
                      <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-[#1F1F1F] text-[#9A9A9A] border border-[#262626]" data-id="element-3121">
                        {r.category}
                      </span>
                    </div>
                    <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3122">
                      {r.description}
                    </div>
                  </div>
                </label>;
          })}
          </div>
        </div>
        <div className="p-5 border-t border-[#262626] flex items-center justify-end" data-id="element-3123">
          <button type="button" onClick={onClose} className="px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-3124">
            Fatto
          </button>
        </div>
      </div>
    </div>;
}
function ReferentiView() {
  const [query, setQuery] = useState('');
  const filtered = STORES.filter(s => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return `${s.manager.name} ${s.name}`.toLowerCase().includes(q);
  });
  return <div className="space-y-6" data-id="element-3125">
      <div data-id="element-3126">
        <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-3127">
          Referenti
        </h1>
      </div>
      <div className="relative w-full sm:w-72" data-id="element-3128">
        <Search className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-3129" />
        <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Cerca referente o store..." className="w-full pl-9 pr-3 py-2 rounded-lg bg-[#181818] border border-[#262626] text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30" data-id="element-3130" />
      </div>
      <div className="bg-[#181818] border border-[#262626] rounded-xl divide-y divide-[#1F1F1F] overflow-hidden" data-id="element-3131">
        {filtered.map(s => <div key={s.id} className="p-4 sm:p-5 flex items-center justify-between gap-4 flex-wrap" data-id="element-3132">
            <div className="flex items-center gap-3 min-w-0" data-id="element-3133">
              <div className="h-10 w-10 rounded-full bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3134">
                <UserCircle className="h-6 w-6 text-[#9A9A9A]" data-id="element-3135" />
              </div>
              <div className="min-w-0" data-id="element-3136">
                <div className="text-sm font-semibold text-[#FAFAFA] truncate" data-id="element-3137">
                  {s.manager.name}
                </div>
                <div className="text-xs text-[#6B6B6B] truncate" data-id="element-3138">{s.name}</div>
              </div>
            </div>
            <div className="flex items-center gap-4 text-xs text-[#9A9A9A] flex-wrap" data-id="element-3139">
              <div className="flex items-center gap-1.5" data-id="element-3140">
                <Mail className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-3141" />
                <span className="font-mono" data-id="element-3142">{s.manager.email}</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-3143">
                <Phone className="h-3.5 w-3.5 text-[#6B6B6B]" data-id="element-3144" />
                <span className="font-mono" data-id="element-3145">{s.manager.phone}</span>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}
function LogicheView({
  assignments,
  globalRuleIds,
  onToggleAssignment,
  onToggleGlobalRule
}: {
  assignments: Record<string, string[]>;
  globalRuleIds: string[];
  onToggleAssignment: (ruleId: string, storeId: string) => void;
  onToggleGlobalRule: (ruleId: string) => void;
}) {
  const [tab, setTab] = useState<'catalogo' | 'applicazioni'>('catalogo');
  const [managingRuleId, setManagingRuleId] = useState<string | null>(null);
  const [pickerStoreId, setPickerStoreId] = useState<string | null>(null);
  const [globalPickerOpen, setGlobalPickerOpen] = useState(false);
  const managingRule = RULES_CATALOG.find(r => r.id === managingRuleId) || null;
  const pickerStore = STORES.find(s => s.id === pickerStoreId) || null;
  const globalRules = RULES_CATALOG.filter(r => globalRuleIds.includes(r.id));
  return <div className="space-y-6" data-id="element-3146">
      <div className="flex items-end justify-between flex-wrap gap-3" data-id="element-3147">
        <div data-id="element-3148">
          <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-3149">
            Regole
          </h1>
        </div>
        {tab === 'catalogo' && <button className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-3150">
            <Plus className="h-4 w-4" data-id="element-3151" />
            Nuova regola
          </button>}
      </div>

      {/* Tabs */}
      <div className="inline-flex items-center gap-1 p-1 rounded-lg bg-[#181818] border border-[#262626]" data-id="element-3152">
        <button onClick={() => setTab('catalogo')} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${tab === 'catalogo' ? 'bg-[#0A0A0A] text-[#FAFAFA] border border-[#262626]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-3153">
          Catalogo regole
          <span className="ml-1.5 text-[#6B6B6B] font-mono" data-id="element-3154">
            {RULES_CATALOG.length}
          </span>
        </button>
        <button onClick={() => setTab('applicazioni')} className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${tab === 'applicazioni' ? 'bg-[#0A0A0A] text-[#FAFAFA] border border-[#262626]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-3155">
          Applicazioni per store
        </button>
      </div>

      {tab === 'catalogo' ? <div className="bg-[#181818] border border-[#262626] rounded-xl divide-y divide-[#1F1F1F] overflow-hidden" data-id="element-3156">
          {RULES_CATALOG.map(r => <RuleRow key={r.id} rule={r} variant="catalog" appliedCount={(assignments[r.id] ?? []).length} onClick={() => setManagingRuleId(r.id)} data-id="element-3157" />)}
        </div> : <div className="space-y-4" data-id="element-3158">
          {/* Global rules — same format as store cards */}
          <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3159">
            <div className="p-4 border-b border-[#262626] flex items-center justify-between gap-2.5 flex-wrap" data-id="element-3160">
              <div className="flex items-center gap-2.5" data-id="element-3161">
                <Globe className="h-4 w-4 text-[#D4FF3A]" data-id="element-3162" />
                <span className="text-sm font-semibold text-[#FAFAFA]" data-id="element-3163">
                  Regole globali
                </span>
                <span className="text-xs text-[#6B6B6B] font-mono" data-id="element-3164">
                  · {globalRules.length}{' '}
                  {globalRules.length === 1 ? 'regola' : 'regole'} · applicate a
                  tutti gli store
                </span>
              </div>
              <button type="button" onClick={() => setGlobalPickerOpen(true)} aria-label="Gestisci regole globali" className="h-7 w-7 rounded-md flex items-center justify-center text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#0A0A0A] border border-transparent hover:border-[#262626] transition" data-id="element-3165">
                <Plus className="h-4 w-4" data-id="element-3166" />
              </button>
            </div>
            {globalRules.length === 0 ? <div className="p-4 text-sm text-[#6B6B6B]" data-id="element-3167">
                Nessuna regola globale applicata.
              </div> : <div className="divide-y divide-[#1F1F1F]" data-id="element-3168">
                {globalRules.map(r => <RuleRow key={r.id} rule={r} variant="applied" data-id="element-3169" />)}
              </div>}
          </div>

          {STORES.map(s => {
        const storeRules = RULES_CATALOG.filter(r => (assignments[r.id] ?? []).includes(s.id));
        return <div key={s.id} className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3170">
                <div className="p-4 border-b border-[#262626] flex items-center justify-between gap-2.5 flex-wrap" data-id="element-3171">
                  <div className="flex items-center gap-2.5" data-id="element-3172">
                    <StoreIcon className="h-4 w-4 text-[#D4FF3A]" data-id="element-3173" />
                    <span className="text-sm font-semibold text-[#FAFAFA]" data-id="element-3174">
                      {s.name}
                    </span>
                    <span className="text-xs text-[#6B6B6B] font-mono" data-id="element-3175">
                      · {storeRules.length}{' '}
                      {storeRules.length === 1 ? 'regola' : 'regole'}
                    </span>
                  </div>
                  <button type="button" onClick={() => setPickerStoreId(s.id)} aria-label={`Aggiungi regola a ${s.name}`} className="h-7 w-7 rounded-md flex items-center justify-center text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#0A0A0A] border border-transparent hover:border-[#262626] transition" data-id="element-3176">
                    <Plus className="h-4 w-4" data-id="element-3177" />
                  </button>
                </div>
                {storeRules.length === 0 ? <div className="p-4 text-sm text-[#6B6B6B]" data-id="element-3178">
                    Nessuna regola applicata.
                  </div> : <div className="divide-y divide-[#1F1F1F]" data-id="element-3179">
                    {storeRules.map(r => <RuleRow key={r.id} rule={r} variant="applied" data-id="element-3180" />)}
                  </div>}
              </div>;
      })}
        </div>}

      {managingRule && <ManageRuleAssignmentsModal rule={managingRule} appliedStoreIds={assignments[managingRule.id] ?? []} onToggle={storeId => onToggleAssignment(managingRule.id, storeId)} onClose={() => setManagingRuleId(null)} data-id="element-3181" />}

      {pickerStore && <StoreRulesPickerModal store={pickerStore} assignments={assignments} onToggle={ruleId => onToggleAssignment(ruleId, pickerStore.id)} onClose={() => setPickerStoreId(null)} data-id="element-3182" />}

      {globalPickerOpen && <GlobalRulesPickerModal activeIds={globalRuleIds} onToggle={onToggleGlobalRule} onClose={() => setGlobalPickerOpen(false)} data-id="element-3183" />}
    </div>;
}
function GlobalRulesPickerModal({
  activeIds,
  onToggle,
  onClose
}: {
  activeIds: string[];
  onToggle: (ruleId: string) => void;
  onClose: () => void;
}) {
  return <div role="dialog" aria-modal="true" onClick={onClose} className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" data-id="element-3184">
      <div onClick={e => e.stopPropagation()} className="w-full sm:max-w-lg bg-[#181818] border border-[#262626] rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden" data-id="element-3185">
        <div className="p-5 border-b border-[#262626] flex items-start gap-3" data-id="element-3186">
          <div className="h-9 w-9 rounded-lg bg-[#D4FF3A]/10 border border-[#D4FF3A]/30 flex items-center justify-center shrink-0" data-id="element-3187">
            <Sparkles className="h-4 w-4 text-[#D4FF3A]" data-id="element-3188" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-3189">
            <h2 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-3190">
              Regole globali
            </h2>
            <p className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3191">
              Le regole selezionate vengono applicate automaticamente a tutti
              gli store.
            </p>
          </div>
          <button type="button" onClick={onClose} aria-label="Chiudi" className="h-7 w-7 rounded flex items-center justify-center text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#222] transition" data-id="element-3192">
            <X className="h-4 w-4" data-id="element-3193" />
          </button>
        </div>
        <div className="p-5" data-id="element-3194">
          <div className="space-y-1 max-h-[60vh] overflow-y-auto" data-id="element-3195">
            {RULES_CATALOG.map(r => {
            const checked = activeIds.includes(r.id);
            return <label key={r.id} className={`flex items-start gap-3 px-3 py-2.5 rounded-lg border cursor-pointer transition ${checked ? 'bg-[#0A0A0A] border-[#D4FF3A]/40' : 'bg-[#0A0A0A] border-[#262626] hover:border-[#333]'}`} data-id="element-3196">
                  <input type="checkbox" checked={checked} onChange={() => onToggle(r.id)} className="sr-only" data-id="element-3197" />
                  <span className={`mt-0.5 h-4 w-4 rounded border-2 shrink-0 flex items-center justify-center ${checked ? 'bg-[#D4FF3A] border-[#D4FF3A]' : 'border-[#262626]'}`} data-id="element-3198">
                    {checked && <svg className="h-3 w-3 text-[#0A0A0A]" viewBox="0 0 12 12" fill="none" data-id="element-3199">
                        <path d="M2 6l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3200" />
                      </svg>}
                  </span>
                  <div className="flex-1 min-w-0" data-id="element-3201">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-3202">
                      <span className="text-sm text-[#FAFAFA] font-medium" data-id="element-3203">
                        {r.title}
                      </span>
                      <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-[#1F1F1F] text-[#9A9A9A] border border-[#262626]" data-id="element-3204">
                        {r.category}
                      </span>
                    </div>
                    <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3205">
                      {r.description}
                    </div>
                  </div>
                </label>;
          })}
          </div>
        </div>
        <div className="p-5 border-t border-[#262626] flex items-center justify-between gap-3 flex-wrap" data-id="element-3206">
          <span className="text-xs text-[#9A9A9A] font-mono" data-id="element-3207">
            {activeIds.length} / {RULES_CATALOG.length} regole globali
          </span>
          <button type="button" onClick={onClose} className="px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-3208">
            Fatto
          </button>
        </div>
      </div>
    </div>;
}
function ManageRuleAssignmentsModal({
  rule,
  appliedStoreIds,
  onToggle,
  onClose
}: {
  rule: Rule;
  appliedStoreIds: string[];
  onToggle: (storeId: string) => void;
  onClose: () => void;
}) {
  return <div role="dialog" aria-modal="true" onClick={onClose} className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" data-id="element-3209">
      <div onClick={e => e.stopPropagation()} className="w-full sm:max-w-lg bg-[#181818] border border-[#262626] rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden" data-id="element-3210">
        <div className="p-5 border-b border-[#262626] flex items-start gap-3" data-id="element-3211">
          <div className="h-9 w-9 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3212">
            <Sliders className="h-4 w-4 text-[#D4FF3A]" data-id="element-3213" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-3214">
            <h2 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-3215">
              {rule.title}
            </h2>
            <p className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3216">{rule.description}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Chiudi" className="h-7 w-7 rounded flex items-center justify-center text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#222] transition" data-id="element-3217">
            <X className="h-4 w-4" data-id="element-3218" />
          </button>
        </div>
        <div className="p-5" data-id="element-3219">
          <div className="text-[11px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-2" data-id="element-3220">
            Applica a store
          </div>
          <div className="space-y-1 max-h-[60vh] overflow-y-auto" data-id="element-3221">
            {STORES.map(s => {
            const checked = appliedStoreIds.includes(s.id);
            return <label key={s.id} className={`flex items-center gap-3 px-3 py-2 rounded-lg border cursor-pointer transition ${checked ? 'bg-[#0A0A0A] border-[#D4FF3A]/40' : 'bg-[#0A0A0A] border-[#262626] hover:border-[#333]'}`} data-id="element-3222">
                  <input type="checkbox" checked={checked} onChange={() => onToggle(s.id)} className="sr-only" data-id="element-3223" />
                  <span className={`h-4 w-4 rounded border-2 shrink-0 flex items-center justify-center ${checked ? 'bg-[#D4FF3A] border-[#D4FF3A]' : 'border-[#262626]'}`} data-id="element-3224">
                    {checked && <svg className="h-3 w-3 text-[#0A0A0A]" viewBox="0 0 12 12" fill="none" data-id="element-3225">
                        <path d="M2 6l3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3226" />
                      </svg>}
                  </span>
                  <StoreIcon className="h-4 w-4 text-[#D4FF3A] shrink-0" data-id="element-3227" />
                  <div className="flex-1 min-w-0" data-id="element-3228">
                    <div className="text-sm text-[#FAFAFA] truncate" data-id="element-3229">
                      {s.name}
                    </div>
                    <div className="text-[11px] text-[#6B6B6B]" data-id="element-3230">{s.city}</div>
                  </div>
                </label>;
          })}
          </div>
        </div>
        <div className="p-5 border-t border-[#262626] flex items-center justify-between gap-3 flex-wrap" data-id="element-3231">
          <span className="text-xs text-[#9A9A9A] font-mono" data-id="element-3232">
            {appliedStoreIds.length} / {STORES.length} store
          </span>
          <button type="button" onClick={onClose} className="px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-3233">
            Conferma
          </button>
        </div>
      </div>
    </div>;
}
function StatisticheView() {
  const sorted = [...STORES].sort((a, b) => b.shipmentsMonth - a.shipmentsMonth);
  const maxShipments = sorted[0]?.shipmentsMonth ?? 1;
  return <div className="space-y-6" data-id="element-3234">
      <div data-id="element-3235">
        <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-3236">
          Statistiche store
        </h1>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-3237">
        {/* Desktop table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-3238">
          <table className="w-full text-sm [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap" data-id="element-3239">
            <thead data-id="element-3240">
              <tr className="text-left text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#1F1F1F]" data-id="element-3241">
                <th className="px-5 py-3 font-medium" data-id="element-3242">Store</th>
                <th className="px-5 py-3 font-medium" data-id="element-3243">Volume mese</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3244">Trend</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3245">Consegna</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3246">ETA media</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3247">Ticket</th>
                <th className="px-5 py-3 font-medium text-right" data-id="element-3248">
                  Giacenze/Ritardi
                </th>
              </tr>
            </thead>
            <tbody data-id="element-3249">
              {sorted.map(s => <tr key={s.id} className="border-b border-[#1F1F1F] last:border-0 hover:bg-[#0A0A0A] transition-colors" data-id="element-3250">
                  <td className="px-5 py-4" data-id="element-3251">
                    <div className="flex items-center gap-2.5" data-id="element-3252">
                      <StoreIcon className="h-4 w-4 text-[#D4FF3A] shrink-0" data-id="element-3253" />
                      <div data-id="element-3254">
                        <div className="text-sm text-[#FAFAFA]" data-id="element-3255">{s.name}</div>
                        <div className="text-[11px] text-[#6B6B6B]" data-id="element-3256">
                          {s.city}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4" data-id="element-3257">
                    <div className="flex items-center gap-3" data-id="element-3258">
                      <span className="font-mono text-[#FAFAFA] text-sm w-12 text-right" data-id="element-3259">
                        {s.shipmentsMonth}
                      </span>
                      <div className="flex-1 h-1.5 bg-[#0A0A0A] rounded-full overflow-hidden min-w-[60px]" data-id="element-3260">
                        <div className="h-full bg-[#D4FF3A]/80 rounded-full" style={{
                      width: `${s.shipmentsMonth / maxShipments * 100}%`
                    }} data-id="element-3261" />
                      </div>
                    </div>
                  </td>
                  <td className="px-5 py-4 text-right" data-id="element-3262">
                    <TrendPill value={s.shipmentsTrend} data-id="element-3263" />
                  </td>
                  <td className={`px-5 py-4 text-right font-mono text-sm ${s.deliveryRate >= 98 ? 'text-[#D4FF3A]' : 'text-[#FAFAFA]'}`} data-id="element-3264">
                    {s.deliveryRate}%
                  </td>
                  <td className="px-5 py-4 text-right text-[#9A9A9A] font-mono text-sm" data-id="element-3265">
                    {s.avgDeliveryDays}g
                  </td>
                  <td className={`px-5 py-4 text-right font-mono text-sm ${s.openTickets > 0 ? 'text-[#F5A524]' : 'text-[#9A9A9A]'}`} data-id="element-3266">
                    {s.openTickets}
                  </td>
                  <td className={`px-5 py-4 text-right font-mono text-sm ${s.pendingIssues > 0 ? 'text-[#EF4444]' : 'text-[#9A9A9A]'}`} data-id="element-3267">
                    {s.pendingIssues}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Mobile cards */}
        <div className="md:hidden divide-y divide-[#1F1F1F]" data-id="element-3268">
          {sorted.map(s => <div key={s.id} className="p-4 space-y-3" data-id="element-3269">
              <div className="flex items-start justify-between gap-3" data-id="element-3270">
                <div className="flex items-center gap-2.5 min-w-0" data-id="element-3271">
                  <StoreIcon className="h-4 w-4 text-[#D4FF3A] shrink-0" data-id="element-3272" />
                  <div className="min-w-0" data-id="element-3273">
                    <div className="text-sm font-semibold text-[#FAFAFA] truncate" data-id="element-3274">
                      {s.name}
                    </div>
                    <div className="text-[11px] text-[#6B6B6B]" data-id="element-3275">{s.city}</div>
                  </div>
                </div>
                <TrendPill value={s.shipmentsTrend} data-id="element-3276" />
              </div>
              <div className="grid grid-cols-4 gap-3 text-xs" data-id="element-3277">
                <div data-id="element-3278">
                  <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3279">
                    Volume
                  </div>
                  <div className="font-mono text-[#FAFAFA] mt-0.5" data-id="element-3280">
                    {s.shipmentsMonth}
                  </div>
                </div>
                <div data-id="element-3281">
                  <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3282">
                    Consegna
                  </div>
                  <div className={`font-mono mt-0.5 ${s.deliveryRate >= 98 ? 'text-[#D4FF3A]' : 'text-[#FAFAFA]'}`} data-id="element-3283">
                    {s.deliveryRate}%
                  </div>
                </div>
                <div data-id="element-3284">
                  <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3285">
                    Ticket
                  </div>
                  <div className={`font-mono mt-0.5 ${s.openTickets > 0 ? 'text-[#F5A524]' : 'text-[#9A9A9A]'}`} data-id="element-3286">
                    {s.openTickets}
                  </div>
                </div>
                <div data-id="element-3287">
                  <div className="text-[10px] uppercase text-[#6B6B6B]" data-id="element-3288">
                    Gia./Rit.
                  </div>
                  <div className={`font-mono mt-0.5 ${s.pendingIssues > 0 ? 'text-[#EF4444]' : 'text-[#9A9A9A]'}`} data-id="element-3289">
                    {s.pendingIssues}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
function StoreStatusBadge({
  status
}: {
  status: 'active' | 'paused';
}) {
  if (status === 'active') return <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-[#D4FF3A]/10 text-[#D4FF3A] border border-[#D4FF3A]/30" data-id="element-3290">
        <span className="h-1.5 w-1.5 rounded-full bg-[#D4FF3A]" data-id="element-3291" />
        Attivo
      </span>;
  return <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-[#1F1F1F] text-[#9A9A9A] border border-[#262626]" data-id="element-3292">
      <span className="h-1.5 w-1.5 rounded-full bg-[#9A9A9A]" data-id="element-3293" />
      In pausa
    </span>;
}
function KpiTile({
  label,
  value,
  icon,
  trend
}: {
  label: string;
  value: string;
  icon: React.ReactNode;
  trend?: number;
}) {
  return <div className="bg-[#181818] border border-[#262626] rounded-xl p-4" data-id="element-3294">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3295">
        {icon}
        <span data-id="element-3296">{label}</span>
      </div>
      <div className="mt-2 flex items-end justify-between gap-2" data-id="element-3297">
        <div className="text-xl font-semibold text-[#FAFAFA] font-heading font-mono" data-id="element-3298">
          {value}
        </div>
        {typeof trend === 'number' && <TrendPill value={trend} data-id="element-3299" />}
      </div>
    </div>;
}
function OperationRow({
  icon,
  label,
  description,
  count,
  countColor,
  actionLabel,
  onAction,
  emptyMessage
}: {
  icon: React.ReactNode;
  label: string;
  description: string;
  count: number;
  countColor: string;
  actionLabel: string;
  onAction?: () => void;
  emptyMessage: string;
}) {
  const hasItems = count > 0;
  return <div className="px-5 py-4 flex items-center justify-between gap-3 flex-wrap" data-id="element-3300">
      <div className="flex items-start gap-3 min-w-0 flex-1" data-id="element-3301">
        <div className="h-8 w-8 rounded-lg bg-[#0A0A0A] border border-[#262626] flex items-center justify-center shrink-0" data-id="element-3302">
          {icon}
        </div>
        <div className="min-w-0" data-id="element-3303">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-3304">
            <span className="text-sm font-medium text-[#FAFAFA]" data-id="element-3305">{label}</span>
            <span className={`text-sm font-mono font-semibold ${countColor}`} data-id="element-3306">
              {count}
            </span>
          </div>
          <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3307">
            {hasItems ? description : emptyMessage}
          </div>
        </div>
      </div>
      {hasItems && onAction && <button type="button" onClick={onAction} className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md bg-[#0A0A0A] border border-[#262626] text-xs font-medium text-[#9A9A9A] hover:text-[#FAFAFA] hover:border-[#333] transition" data-id="element-3308">
          {actionLabel}
          <ChevronRight className="h-3 w-3" data-id="element-3309" />
        </button>}
    </div>;
}
function Stat({
  label,
  value,
  trend,
  highlight
}: {
  label: string;
  value: string;
  trend?: number;
  highlight?: boolean;
}) {
  return <div data-id="element-3310">
      <div className="text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium" data-id="element-3311">
        {label}
      </div>
      <div className="flex items-center gap-2 mt-0.5" data-id="element-3312">
        <div className={`text-sm font-semibold font-mono ${highlight ? 'text-[#D4FF3A]' : 'text-[#FAFAFA]'}`} data-id="element-3313">
          {value}
        </div>
        {typeof trend === 'number' && <TrendPill value={trend} small data-id="element-3314" />}
      </div>
    </div>;
}
function TrendPill({
  value,
  small
}: {
  value: number;
  small?: boolean;
}) {
  const positive = value >= 0;
  const Icon = positive ? TrendingUp : TrendingDown;
  return <span className={`inline-flex items-center gap-0.5 ${small ? 'text-[10px]' : 'text-[11px]'} font-medium font-mono ${positive ? 'text-[#D4FF3A]' : 'text-[#EF4444]'}`} data-id="element-3315">
      <Icon className={small ? 'h-2.5 w-2.5' : 'h-3 w-3'} data-id="element-3316" />
      {positive ? '+' : ''}
      {value.toFixed(1)}%
    </span>;
}
function RuleRow({
  rule,
  variant = 'applied',
  appliedCount,
  onClick
}: {
  rule: Rule;
  variant?: 'applied' | 'catalog';
  appliedCount?: number;
  onClick?: () => void;
}) {
  return <div className="p-3 sm:p-4 flex items-start justify-between gap-3" data-id="element-3317">
      <div className="flex items-start gap-2.5 min-w-0 flex-1" data-id="element-3318">
        <Sliders className="h-4 w-4 text-[#9A9A9A] shrink-0 mt-0.5" data-id="element-3319" />
        <div className="min-w-0" data-id="element-3320">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-3321">
            <span className="text-sm font-medium text-[#FAFAFA]" data-id="element-3322">
              {rule.title}
            </span>
            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-[#1F1F1F] text-[#9A9A9A] border border-[#262626]" data-id="element-3323">
              {rule.category}
            </span>
          </div>
          <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-3324">
            {rule.description}
          </div>
          {variant === 'catalog' && typeof appliedCount === 'number' && <div className="text-[11px] text-[#6B6B6B] mt-1.5 font-mono" data-id="element-3325">
              Applicata a {appliedCount}{' '}
              {appliedCount === 1 ? 'store' : 'store'}
            </div>}
        </div>
      </div>
      {onClick && <button type="button" onClick={onClick} className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-[#0A0A0A] border border-[#262626] text-xs text-[#9A9A9A] hover:text-[#FAFAFA] hover:border-[#333] transition" data-id="element-3326">
          {variant === 'catalog' ? <>
              <Sliders className="h-3 w-3" data-id="element-3327" />
              Gestisci
            </> : 'Rimuovi'}
        </button>}
    </div>;
}